"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useOutsideClick;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

function useOutsideClick(ref, handler) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isListening = _useState2[0],
      setIsListening = _useState2[1];

  var listener = (0, _react.useMemo)(function () {
    return function (event) {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };
  }, [ref, handler]);
  (0, _react.useEffect)(function () {
    if (isListening) {
      document.addEventListener('mousedown', listener);
      document.addEventListener('touchstart', listener);
    }

    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [isListening, listener]);
  return [function () {
    return setIsListening(true);
  }, function () {
    return setIsListening(false);
  }];
}